module.exports = __webpack_public_path__ + "welcome_generic.jpg?14558b44318ac4e2bf00e982d813b84f";


//////////////////
// WEBPACK FOOTER
// ./src/kits/1/images/welcome_generic.jpg
// module id = 485
// module chunks = 0